// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"TransferStatusSection_buttonWrapper__2-88N","strong":"TransferStatusSection_strong__2lm4q"};